module.exports = __webpack_public_path__ + "static/media/3.dc177b84.jpg";